module.exports = __webpack_public_path__ + "images/feature/inbox-img3-d059b82411d299f80dadd672b370de4f.png";